import { Container } from "./container";

const rp = new Container();
export default rp;
